module.exports = __webpack_public_path__ + "img/preview-4.d89c35ee.png";